var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Col, Row } from "react-bootstrap";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
var Segment = function (props) {
    var _a = __read(React.useState(), 2), segmentData = _a[0], setSegmentData = _a[1];
    React.useEffect(function () {
        setSegmentData(props.data);
    }, [props.data]);
    var SegmentColumn = [
        {
            columnName: "",
            key: "niftyrow",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "CASH",
            key: "cash",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "F&O",
            key: "FoRow",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "CDS",
            key: "cds",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "COMMODITY",
            key: "commodity",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "MF",
            key: "mfrow",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
    ];
    var SegmentRows = [
        {
            niftyrow: "BSE",
            cash: segmentData === null || segmentData === void 0 ? void 0 : segmentData.bsE_Cash,
            FoRow: segmentData === null || segmentData === void 0 ? void 0 : segmentData.bsE_FO,
            cds: segmentData === null || segmentData === void 0 ? void 0 : segmentData.bsE_CDS,
            commodity: segmentData === null || segmentData === void 0 ? void 0 : segmentData.bsE_Commodity,
            mfrow: segmentData === null || segmentData === void 0 ? void 0 : segmentData.bsE_MF,
        },
        {
            niftyrow: "NSE",
            cash: segmentData === null || segmentData === void 0 ? void 0 : segmentData.nsE_Cash,
            FoRow: segmentData === null || segmentData === void 0 ? void 0 : segmentData.nsE_FO,
            cds: segmentData === null || segmentData === void 0 ? void 0 : segmentData.nsE_CDS,
            commodity: segmentData === null || segmentData === void 0 ? void 0 : segmentData.nsE_Commodity,
            mfrow: segmentData === null || segmentData === void 0 ? void 0 : segmentData.nsE_MF,
        },
        {
            niftyrow: "MCX",
            cash: segmentData === null || segmentData === void 0 ? void 0 : segmentData.mcX_Cash,
            FoRow: segmentData === null || segmentData === void 0 ? void 0 : segmentData.mcX_FO,
            cds: segmentData === null || segmentData === void 0 ? void 0 : segmentData.mcX_CDS,
            commodity: segmentData === null || segmentData === void 0 ? void 0 : segmentData.mcX_Commodity,
            mfrow: segmentData === null || segmentData === void 0 ? void 0 : segmentData.mcX_MF,
        },
        {
            niftyrow: "NCDEX",
            cash: segmentData === null || segmentData === void 0 ? void 0 : segmentData.ncdeX_Cash,
            FoRow: segmentData === null || segmentData === void 0 ? void 0 : segmentData.ncdeX_FO,
            cds: segmentData === null || segmentData === void 0 ? void 0 : segmentData.ncdeX_CDS,
            commodity: segmentData === null || segmentData === void 0 ? void 0 : segmentData.ncdeX_Commodity,
            mfrow: segmentData === null || segmentData === void 0 ? void 0 : segmentData.ncdeX_MF,
        },
    ];
    return (React.createElement("section", { className: "section-padding" },
        React.createElement(Row, { className: "relationship-head-block mx-0 px-0" },
            React.createElement(Col, { className: "DMSanBold_18_700 txt_blackOne1 px-0" }, "Segment"),
            React.createElement(Col, { className: "DMSanN_14_400 txt_blackOne1 px-0 d-flex justify-content-end" },
                "Recommended Segment: \u00A0",
                React.createElement("span", { className: "DMSan_14_700" }, segmentData === null || segmentData === void 0 ? void 0 : segmentData.segments))),
        React.createElement(GenericTable, { columns: SegmentColumn, data: SegmentRows, parentClassName: "salestableParentClass", tableClassName: "salestableclass" })));
};
export default Segment;
